/* @flow */
import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Subtitle = ({ children, className }) => (
  <h2 className={`subtitle ${className}`}>{children}</h2>
);

Subtitle.defaultProps = {
  children: '',
  className: ''
};

Subtitle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
};

export default Subtitle;
